import { Card, Typography, Button, Modal } from "antd";
import { Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import dayjs from "dayjs";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend,} from "chart.js";
import { useRef, useState } from "react";
import { ExpandOutlined, DownloadOutlined } from "@ant-design/icons";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

const { Title } = Typography;

export function ProgressChart({ data }) {
  const chartRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const chartData = {
    labels: data.map((d) => dayjs(d.fecha).format("YYYY-MM-DD")),
    datasets: [
      {
        label: "Verificado",
        data: data.map((d) => d.verificado),
        backgroundColor: "#20AC00",
        borderColor: "#20AC00",
        tension: 0.3,
        borderWidth: 2,
      },
      {
        label: "En Proceso",
        data: data.map((d) => d.enProceso),
        backgroundColor: "#419DF8",
        borderColor: "#419DF8",
        tension: 0.3,
        borderWidth: 2,
      },
      {
        label: "No Continua",
        data: data.map((d) => d.noContinua),
        backgroundColor: "rgba(255, 99, 132, 0.4)",
        borderColor: "rgba(255, 99, 132, 1)",
        tension: 0.3,
        borderWidth: 2,
      },
      {
        label: "No Verificado",
        data: data.map((d) => d.noVerificado),
        backgroundColor: "rgba(201, 203, 207, 0.4)",
        borderColor: "rgba(201, 203, 207, 1)",
        tension: 0.3,
        borderWidth: 2,
      },
    ],
  };

  const baseOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { 
        position: "bottom",
        labels: {
          usePointStyle: true,
          padding: 15,
        }
      },
      datalabels: { display: false },
    },
    scales: {
      y: { 
        beginAtZero: true,
        grid: {
          color: 'rgba(0, 0, 0, 0.05)',
        }
      },
      x: {
        grid: {
          color: 'rgba(0, 0, 0, 0.05)',
        }
      },
    },
  };

  const downloadChart = () => {
    if (chartRef.current) {
      const chartInstance = chartRef.current;
      const originalCanvas = chartInstance.canvas;
      const tempCanvas = document.createElement('canvas');
      const tempCtx = tempCanvas.getContext('2d');
      tempCanvas.width = originalCanvas.width;
      tempCanvas.height = originalCanvas.height;
      tempCtx.fillStyle = 'white';
      tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
      tempCtx.drawImage(originalCanvas, 0, 0);
      const image = tempCanvas.toDataURL('image/png', 1.0);
      const link = document.createElement('a');
      link.download = `evolucion-verificaciones-${dayjs().format('YYYY-MM-DD')}.png`;
      link.href = image;
      link.click();
    }
  };

  const modalOptions = {
    ...baseOptions,
    plugins: {
      ...baseOptions.plugins,
      legend: {
        position: "bottom",
        labels: {
          font: {
            size: 14
          },
          usePointStyle: true,
          padding: 20,
        }
      }
    },
    scales: {
      y: { 
        beginAtZero: true,
        grid: {
          color: 'rgba(0, 0, 0, 0.05)',
        },
        ticks: {
          font: {
            size: 12
          }
        }
      },
      x: {
        grid: {
          color: 'rgba(0, 0, 0, 0.05)',
        },
        ticks: {
          font: {
            size: 12
          }
        }
      },
    },
  };

  return (
    <>
      <Card 
        style={{ borderRadius: 12 }}
        extra={
          <div style={{ display: 'flex', gap: 8 }}>
            <Button 
              icon={<ExpandOutlined />} 
              size="small"
              onClick={() => setIsModalOpen(true)}
              title="Maximizar gráfica"
            />
            <Button 
              icon={<DownloadOutlined />} 
              size="small"
              onClick={downloadChart}
              title="Descargar como imagen"
            />
          </div>
        }
      >
        <Title level={5}>Evolución diaria de verificaciones</Title>
        <div style={{ height: 430 }}>
          <Line 
            ref={chartRef}
            data={chartData} 
            options={baseOptions} 
          />
        </div>
      </Card>
      <Modal
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Evolución diaria de verificaciones - Vista ampliada</span>
            <Button 
              icon={<DownloadOutlined />} 
              size="small"
              onClick={downloadChart}
            >
              Descargar
            </Button>
          </div>
        }
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width="90vw"
        style={{ maxWidth: 1200 }}
      >
        <div style={{ 
          height: '70vh', 
          minHeight: 500,
          background: 'white',
          padding: 24 
        }}>
          <Line 
            ref={chartRef}
            data={chartData} 
            options={modalOptions} 
          />
        </div>
      </Modal>
    </>
  );
}